import { render } from "./autoComplete.vue?vue&type=template&id=f9392978"
import script from "./autoComplete.vue?vue&type=script&lang=js"
export * from "./autoComplete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\POS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__